import { View } from 'rune-ts';

export abstract class BaseSectionTitlePlugin<T extends object, CT extends Partial<T>> {
  public abstract ViewClass: typeof View<T>;
  public abstract default_view_data: T;
  public custom_view_data?: CT;

  public abstract makeViewInstance(custom_view_data: CT): InstanceType<typeof this.ViewClass>;

  public makeViewData = (custom_view_data?: CT): T => {
    if (custom_view_data) {
      return {
        ...this.default_view_data,
        ...custom_view_data,
      };
    }
    return this.default_view_data;
  };
}
